import { slice, INITIAL_STATE, FacilityState } from './slice';
import { PersistConfig, PersistState, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// ****************************************************************************************

const currentVersion = 4; // increment this number every time the state contract changes

// ****************************************************************************************

const persistenceConfig: PersistConfig<FacilityState> = {
  key: 'profile/facility',
  storage,
  whitelist: ['companyAlias', 'companyId', 'facilityAlias', 'facilityCode', 'id'],
  version: currentVersion,
  migrate: (state, version) => {
    if (!state || (state._persist && state._persist.version < version)) {
      return Promise.resolve(INITIAL_STATE as FacilityState & { _persist: PersistState });
    }
    return Promise.resolve(state);
  },
};

export const persistedReducer = persistReducer(persistenceConfig, slice.reducer);
